export default __webpack_public_path__ + "static/media/team-member-06.29cec32e.jpg";